import React from "react";
import img1 from "../visionassets/enhance.png";
import "./VisionEnhance.css";
import CheckIcon from "@mui/icons-material/Check";

export default function VisionEnhance() {
  return (
    <section id="vision-enhance">
      <div className="outsource-offer-main">
        <div className="offer-item image">
          <img src={img1} alt="DevOps Image 2" />
        </div>
        <div className="offer-item content content2">
          <h2>Dynamic Offerings in DevOps Test Automation</h2>
          <p>
            Computer vision can support your business in multiple ways,
            delivering efficiency, insight, and competitive advantage:
          </p>
          <ul>
            <li>
              <CheckIcon />
              Automate object detection, tracking, and labeling.
            </li>
            <li>
              <CheckIcon /> Enhance safety with content moderation and
              surveillance.
            </li>
            <li>
              <CheckIcon /> Improve decisions through large-scale image and
              video analysis.
            </li>
            <li>
              <CheckIcon /> Generate realistic images and videos.
            </li>
            <li>
              <CheckIcon /> Streamline data entry and document processing with
              ICR.
            </li>
            <li>
              <CheckIcon /> Gain a competitive edge via auto-tagging and content
              categorization.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
